export const teamMembers = [
  {
    id: 1,
    name: 'Engin POLAT',
    phone: '0507 607 4165',
    phoneHref: 'tel:+905076074165',
    whatsapp: 'https://wa.me/905076074165?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum.',
    avatar: 'https://public.readdy.ai/ai/img_res/9bb2a41592f29998b5e3131dab1a84f6.jpg',
  },
  {
    id: 2,
    name: 'Hamza POLAT',
    phone: '0543 820 7155',
    phoneHref: 'tel:+905438207155',
    whatsapp: 'https://wa.me/905438207155?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20plumber%20portrait%2C%20dark%20blue%20work%20shirt%2C%20friendly%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20late%2020s%20man%2C%20skilled%20tradesman%20appearance&width=300&height=300&seq=t2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Hayrullah POLAT',
    phone: '0543 641 2016',
    phoneHref: 'tel:+905436412016',
    whatsapp: 'https://wa.me/905436412016?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20plumber%20portrait%2C%20light%20blue%20work%20uniform%2C%20warm%20friendly%20smile%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20early%2030s%20man%2C%20skilled%20professional%20worker&width=300&height=300&seq=t3&orientation=squarish',
  },
];

export const primaryContact = teamMembers[0];
